import { useTranslation } from "react-i18next";
import { Grid, Switch, Text } from "@mantine/core";
import { CampaignQueryDataType } from "src/hooks/campaigns";
import { checkDeliveryType } from "src/utils/helpers";

import { FormItem } from "../../../../FormItem";
import { RichTextEditor } from "../../../../RichTextEditor";

export interface AssignmentDeliveryDetailProps {
    campaign: CampaignQueryDataType;
}

export const AssignmentDeliveryDetail = ({ campaign }: AssignmentDeliveryDetailProps) => {
    const { t } = useTranslation(["common"]);

    return (
        <Grid>
            <Grid.Col xs={12} sm={12} md={4}>
                <Switch
                    mb="xl"
                    color="gray"
                    label={t("campaign_delivery_free_of_charge")}
                    checked={campaign?.delivery?.freeOfCharge}
                    onChange={() => {}}
                />
                <FormItem label={t("campaign_delivery_type")}>
                    {campaign?.delivery?.type && checkDeliveryType(campaign?.delivery?.type) ? (
                        t(`campaign_delivery_type_${campaign?.delivery?.type}`)
                    ) : (
                        <Text color="dimmed">-</Text>
                    )}
                </FormItem>
            </Grid.Col>
            <Grid.Col xs={12} sm={12} md={8}>
                <FormItem label={t("campaign_delivery_note")}>
                    {campaign?.delivery?.notes || <Text color="dimmed">-</Text>}
                </FormItem>
            </Grid.Col>
            <Grid.Col xs={12}>
                <FormItem label={t("campaign_delivery_instructions")}>
                    {campaign?.delivery?.instructions?.json && (
                        <RichTextEditor value={{ json: campaign.delivery.instructions.json }} readOnly />
                    )}
                </FormItem>
            </Grid.Col>
        </Grid>
    );
};
